import React, { useEffect, useRef } from "react";
import style from '../commentInsight.module.scss';
import toPersianNumber from "../../../helpers/actions/toPersianNumber";
import { Chart } from "chart.js";

let myLineChart;
Chart.defaults.global.defaultFontFamily = "IRANSans";

const Tab = (props) => {

    const refrence = useRef()

    useEffect(() => {
        if (typeof refrence.current != 'undefined') {
            const myChartRef = refrence.current.getContext("2d");
            window[myLineChart + props.tag] = new Chart(myChartRef, {
                type: "bar",
                data: {
                    //Bring in data
                    labels: props.aiInsights.map(el => el.title),
                    datasets: [
                        {
                            label: "مثبت",
                            data: props.aiInsights.map(el => el.tag_data.positive),
                            fill: false,
                            borderColor: "#192a56",
                            backgroundColor: "#192a56",
                        },
                        {
                            label: "بی‌طرف",
                            data: props.aiInsights.map(el => el.tag_data.neutral),
                            fill: false,
                            borderColor: "#e3d185",
                            backgroundColor: "#e3d185",
                        },
                        {
                            label: "منفی",
                            data: props.aiInsights.map(el => el.tag_data.negative),
                            fill: false,
                            borderColor: "#dbe4ff",
                            backgroundColor: "#dbe4ff",
                        }
                    ]
                },
                gridLines: {
                    display: false
                },
                options: {
                    responsive: true,
                    layout: {
                        padding: {
                            top: 5
                        }
                    },
                    legend: {
                        display: true,
                    },
                    scales: {
                        xAxes: [{
                            gridLines: {
                                display: true
                            }
                        }],
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                callback: function (value, index, values) {
                                    return (value % 1 == 0 ? toPersianNumber(value) : '')
                                }
                            }
                        }]
                    },
                    tooltips: {
                        callbacks: {
                            label: function (tooltipItem, chart) {
                                let string = `تعداد دیدگاه: ${toPersianNumber(tooltipItem.value)}`
                                return string
                            }
                        }
                    }
                },
            });
        }
    }, [props]);

    const defineTitle = title => {
        let result = ''
        switch (title) {
            case 'recommended':
                result = 'پیشنهاد کرده‌اند'
                break;
            case 'not_recommended':
                result = 'پیشنهاد نکرده‌اند'
                break;
            case 'no_idea':
                result = 'مطمئن نیستند'
                break;
        }
        return result
    }

    return (
        <>
            <div className={style.recommendedWrapper}>
                {props.allRecommendations != 0 && Object.keys(props.recommendation_status).map((sellerItem, sellerIndex) => <div
                    key={`_sellerRecommendations${sellerIndex}`}
                    className={style[Object.keys(props.recommendation_status)[sellerIndex]]}
                    style={{ width: `${(100 * props.recommendation_status[sellerItem]) / props.allRecommendations}%` }}
                >
                    <div className={style.recommendedToolTip}>
                        {toPersianNumber((props.recommendation_status[sellerItem]))} نفر {defineTitle(sellerItem)}
                    </div>
                    {toPersianNumber(parseInt((100 * props.recommendation_status[sellerItem]) / props.allRecommendations))}%

                </div>)}
            </div>

            {props.aiInsights && <div className={style.aiInsightsWrapper}>
                <canvas ref={refrence} style={{ boxSizing: "border-box", width: "100%" }} height="200"></canvas>
            </div>}

            <div className={style.allCommentsWrapper}>
                {props.comments.map((sellerComment, sellerCommentIndex) => <div key={`_sellercomments${sellerCommentIndex}`}>
                    <div className={style.singleComment}>
                        <p className={style.body} data-content={toPersianNumber(sellerComment.rate + '.0')}>{sellerComment.body}</p>
                        <div className={style.seprator}></div>
                        <div className={style.moreDetails}>
                            <p>{toPersianNumber(sellerComment.created_at)}</p>
                            {sellerComment.purchased_item && sellerComment.purchased_item.color && <p className={style.colorWrapper}>
                                <span className={style.color} style={{ backgroundColor: `${sellerComment.purchased_item.color.hex_code}` }}></span>{sellerComment.purchased_item.color.title}
                            </p>}
                            {sellerComment.purchased_item && sellerComment.purchased_item.size && <p>
                                {sellerComment.purchased_item.size.title}
                            </p>}
                            <p>{sellerComment.user_name ? sellerComment.user_name : 'کاربر ناشناس'}</p>
                        </div>
                    </div>
                </div>)}
            </div>
        </>
    )
}
export default Tab